import apiFetch from '../../apiFetch'

export default function (dossierId, token) {
  return apiFetch({
    endPoint: `dossier/dossierBudgetComponent/${dossierId}`,
    method: 'GET',
    body: null,
    token: token
  })
}
